var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgProwritingStats = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 112,
    height: 97,
    viewBox: "0 0 112 97",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #9bc83a;\n      }\n\n      .cls-2 {\n        stroke: #40535e;\n        stroke-miterlimit: 10;\n      }\n\n      .cls-2, .cls-3 {\n        fill: #fff;\n      }\n\n      .cls-4 {\n        fill: #c5c5c5;\n      }\n\n      .cls-5 {\n        fill: #c00a46;\n      }\n\n      .cls-6 {\n        fill: #f7981d;\n      }\n\n      .cls-7 {\n        fill: #ecc609;\n      }\n\n      .cls-8 {\n        fill: #13bd68;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 39.24,
    y: 42,
    width: 55,
    height: 55,
    rx: 5,
    ry: 5,
    transform: "translate(136.24 2.76) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 16.14,
    y: 0,
    width: 55,
    height: 55,
    rx: 5,
    ry: 5,
    transform: "translate(71.14 -16.14) rotate(90)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 11.88,
    y: 17.5,
    width: 85.24,
    height: 62,
    rx: 5,
    ry: 5,
    transform: "translate(103 -6) rotate(90)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 30.85,
    y: 15.28,
    width: 45.71,
    height: 2.5,
    rx: 1.25,
    ry: 1.25,
    transform: "translate(107.42 33.07) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 30.85,
    y: 43.42,
    width: 45.71,
    height: 2.5,
    rx: 1.25,
    ry: 1.25,
    transform: "translate(107.42 89.34) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 30.85,
    y: 51.42,
    width: 45.71,
    height: 2.5,
    rx: 1.25,
    ry: 1.25,
    transform: "translate(107.42 105.34) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 30.85,
    y: 21.91,
    width: 34.03,
    height: 2.5,
    rx: 1.25,
    ry: 1.25,
    transform: "translate(95.73 46.31) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 30.85,
    y: 59.42,
    width: 34.03,
    height: 2.5,
    rx: 1.25,
    ry: 1.25,
    transform: "translate(95.73 121.34) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 30.85,
    y: 30.08,
    width: 39.82,
    height: 2.5,
    rx: 1.25,
    ry: 1.25,
    transform: "translate(101.52 62.66) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 30.85,
    y: 74.35,
    width: 39.82,
    height: 2.5,
    rx: 1.25,
    ry: 1.25,
    transform: "translate(101.52 151.21) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 30.85,
    y: 80.97,
    width: 9,
    height: 2.5,
    rx: 1.25,
    ry: 1.25,
    transform: "translate(70.7 164.45) rotate(180)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 13.79,
    cy: 62.88,
    r: 13.79
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 12.13,
    y: 56.19,
    width: 3.43,
    height: 9.45,
    rx: 0.3,
    ry: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M15.56,67.66v2.84c0,.17-.14,.29-.3,.3h-2.83c-.17,0-.3-.14-.3-.3v-2.84c0-.17,.14-.3,.3-.3h2.83c.17,0,.3,.14,.3,.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M24.67,69.58l-2.95-1.71c1.7-2.93,1.7-6.55,0-9.48h0c-.82-1.42-1.99-2.6-3.4-3.44-1.46-.86-3.12-1.31-4.81-1.31v-3.41c2.25,0,4.48,.6,6.43,1.73,6.17,3.56,8.29,11.45,4.73,17.62Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 94.97,
    cy: 17.03,
    r: 17.03
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M89.48,15.26c-.19,0-.37,.08-.49,.23l-1.04,1.02c-.26,.29-.26,.73,0,1.02l4.71,4.68c.25,.28,.69,.3,.97,.05,.02-.02,.03-.03,.05-.05l8.32-8.29c.26-.29,.26-.73,0-1.02l-1.04-1.02c-.12-.15-.3-.23-.49-.23-.2,0-.39,.08-.52,.23l-6.76,6.77-3.16-3.16c-.14-.14-.33-.23-.53-.22Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 102,
    cy: 87,
    r: 10
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M98.62,88.94l2-2-2-2.01c-.12-.11-.19-.27-.19-.44s.07-.33,.19-.46l.44-.44c.12-.12,.29-.18,.46-.18,.16,0,.32,.06,.44,.18l2,2,2-2c.12-.12,.28-.19,.44-.18,.17,0,.34,.06,.46,.18l.45,.44c.11,.12,.18,.29,.18,.46s-.07,.33-.18,.44l-2,2.01,2,2c.11,.12,.18,.28,.18,.44,0,.17-.07,.34-.18,.46l-.45,.44c-.12,.12-.29,.19-.46,.19-.16,0-.32-.07-.44-.19l-2-2-2,2.01c-.12,.12-.28,.18-.44,.18-.17,0-.34-.07-.46-.18l-.44-.44c-.12-.13-.19-.29-.19-.47,0-.16,.07-.32,.19-.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M106.29,94.76c-4.25,2.35-9.59,.81-11.94-3.44h.01c-1.58-2.71-1.58-6.06,0-8.78l2.01,1.16c-1.16,2-1.16,4.47,0,6.47h0c.56,.96,1.36,1.77,2.32,2.34,2.02,1.19,4.53,1.19,6.56,0,.96-.57,1.76-1.38,2.32-2.34,1.78-3.08,.74-7.01-2.32-8.81-1-.59-2.13-.9-3.28-.89v-2.33c3.14,0,6.04,1.69,7.61,4.4,.05,.09,.11,.19,.16,.28,2.35,4.25,.81,9.6-3.44,11.94Z"
  })))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgProwritingStats);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/pro.writingStats.063e69e6b222666d63de83983a1b63e1.svg";